import { getProgramAccreditedPaged, deleteAccredited } from '@bforms-web/common';

import AccreditedList, { ProgramAccreditedListProps } from '../../components/Accredited/list';

const dispatchers: Pick<ProgramAccreditedListProps, 'getProgramAccreditedPaged' | 'deleteAccredited'> = {
  getProgramAccreditedPaged,
  deleteAccredited,
};

export default function ProgramAccreditedListComposer(): JSX.Element {
  return <AccreditedList {...dispatchers} />;
}
